







import Vue from 'vue'
import roles from '@/services/Roles'

export default Vue.extend({
  name: 'OwnerOnly',
  props: {
    restaurantId: String,
  },
  data() {
    return {
      authorized: true,
    }
  },
  async created() {
    this.authorized = await roles.isOwner(this.restaurantId)
  },
})
